<template>
  <div
    :class="{
      'match-content': activityIndex == 3,
      'activity-content': activityIndex !== 3,
    }"
  >
    <!-- <template>
      <a
        :href="`${origin}/match/CUDIA`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img src="https://image.manamana.net/1609151306175_eqkq4Usi?imageView2/1/w/746/h/420" />
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">中国高校数字交互艺术大赛——彩焕南云探索计划</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">Chinese University Digital Interactive art Awards</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12" v-if="language == 'zh'">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/1566552429231_wgL9rqVm?imageView2/1/w/18/h/18"
                />云南艺术学院设计学院数字媒体艺术
              </div>
              <div data-v-7c904a26 class="font-overflow safari12" v-if="language == 'en'">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/1566552429231_wgL9rqVm?imageView2/1/w/18/h/18"
                />云南艺术学院设计学院数字媒体艺术
              </div>
              <span data-v-7c904a26 class="holdTime safari12">20-10-10{{$t('global.至')}}21-01-03</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/match/2020lighteningselection`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img src="https://image.manamana.net/1608717136212_06J0R5uL?imageView2/1/w/746/h/420" />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">2020光子国际艺术大赛</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">2020 CITIC Press Lightening Selection</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12" v-if="language == 'zh'">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/1591853587049_5TIi0f91?imageView2/1/w/18/h/18"
                />中信出版多媒体未来实验室
              </div>
              <div data-v-7c904a26 class="font-overflow safari12" v-if="language == 'en'">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/1591853587049_5TIi0f91?imageView2/1/w/18/h/18"
                />CITIC Press Multimedia Lab
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2020-06-15{{$t('global.至')}}2020-10-15</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/subjectdetail/71`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img
              src="https://image.manamana.net/lumieres-shanghai2020.jpg?imageView2/1/w/746/h/420"
            />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">2020「光影上海」作品公开征集</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">2020 LUMIERES SHANGHAI Open Call</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img data-v-7c904a26 src="/static/sample/avatar.png" />MANA{{$t('global.竞赛小助手')}}
              </div>
              <span data-v-7c904a26 class="holdTime safari12">{{$t('global.即日起至')}}2020-7-31</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/match/lifegeek2020`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img src="https://image.manamana.net/images/2020-0520-Life Geek-750_422px.jpg?imageView2/1/w/746/h/420" />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">第五届“汇创青春” 上海大学生文化创意作品展示活动 国际赛新媒体艺术分赛</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">The 5th“Think Youth”- International Competition New Media Art Section</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/avatar/1524824064/mana_o_1cc39hgch1ugrfhp13ok136u15jn7.png?imageView2/1/w/18/h/18"
                />LIFE GEEK
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2020-05-27{{$t('global.至')}}2020-08-31</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/subjectdetail/193`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img src="https://image.manamana.net/images/2020-0513-oppo-banner-16_9.jpg?imageView2/1/w/746/h/420" />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top">OPPO校园 Renovators 全球青年创作计划</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/1557112190269_oppo%E6%A0%A1%E5%9B%AD%E5%A4%B4%E5%83%8F2.jpg?imageView2/1/w/18/h/18"
                />Reno-vators
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2020-05-06{{$t('global.至')}}2020-07-31</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/match/ACSEEFestival`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img
              src="https://image.manamana.net/images/3%E7%BC%A9%E7%95%A5%E5%9B%BE.jpg?imageView2/1/w/746/h/420"
            />
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">ACSEE 首届中国国际光影大赛大同站</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">ACSEE Video Mapping Contest in Datong</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img data-v-7c904a26 src="https://image.manamana.net/1576824100907_YzhR6oaR?imageView2/1/w/100/h/100" />ACSEE FESTIVAL
              </div>
              <span data-v-7c904a26 class="holdTime safari12">即日起至2020-02-16</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/match/SpoonbillCup`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img
              src="https://image.manamana.net/images/191204-%E6%B4%BB%E5%8A%A8-%E7%90%B5%E9%B9%AD%E6%9D%AF-banner-750-422px-re.png?imageView2/1/w/746/h/420"
            />
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">2019第三届深圳“琵鹭杯”公共艺术优秀作品展</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">2019 the 3rd Shenzhen Spoonbill Cup Public Art Exhibition</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img data-v-7c904a26 src="https://image.manamana.net/1571649702005_MrnHc6HH?imageView2/1/w/100/h/100" />SpoonbillCup
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2019年10月~12月</span>
            </div>
          </div>
        </div>
      </a>

      <a
        :href="`${origin}/match/NewMediaArtof2020SuccessfulDesignAwards`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img
              src="https://image.manamana.net/images/0923_%E6%88%90%E5%8A%9F%E8%AE%BE%E8%AE%A1_mobile_banner_750_422px.jpg?imageView2/1/w/746/h/420"
            />
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top" v-if="language == 'zh'">2020年成功设计大赛新媒体艺术类</div>
            <div data-v-7c904a26 class="top" v-if="language == 'en'">New Media Art of 2020 Successful Design Awards</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img data-v-7c904a26 src="https://image.manamana.net/1569387588111_ATfD3XCg?imageView2/1/w/100/h/100" />2020成功设计大赛
              </div>
              <span data-v-7c904a26 class="holdTime safari12">{{$t('global.即日起至')}}2019-12-23</span>
            </div>
          </div>
        </div>
      </a>

      <a
        :href="`${origin}/subjectdetail/140`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img
              src="https://image.manamana.net/images/CIDI_event.png?imageView2/1/w/746/h/420"
            />
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top">2019中国工业设计研究院设计大奖</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img data-v-7c904a26 src="https://image.manamana.net/1565752243019_JWjRnTLj?imageView2/1/w/100/h/100" />中国工业设计研究院设计大奖
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2019-06-18{{$t('global.至')}}2019-10-31</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/subjectdetail/100`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img src="https://image.manamana.net/oppo_banner_16_9-01.png?imageView2/1/w/746/h/420" />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top">Reno-vators全球青年创作计划</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/1557112190269_oppo%E6%A0%A1%E5%9B%AD%E5%A4%B4%E5%83%8F2.jpg?imageView2/1/w/18/h/18"
                />Reno-vators
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2019-05-05{{$t('global.至')}}2019-05-19</span>
            </div>
          </div>
        </div>
      </a>
      <a
        :href="`${origin}/subjectdetail/60`"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img
              src="https://image.manamana.net/1552964484441_791483236.jpg?imageView2/1/w/746/h/420"
            />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top">英国流明艺术与科技大奖（2019年）</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/logo2.jpg?imageView2/1/w/18/h/18"
                />Lumen Prize
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2019-03-20{{$t('global.至')}}2019-05-03</span>
            </div>
          </div>
        </div>
      </a>
      <router-link
        :to="{name: 'presentfuture', params: {matchId:1003}}"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div data-v-7c904a26 class="item-img">
            <img src="/static/peopleCenter/lifegeekbg.jpg?imageView2/1/w/746/h/420" />
            <div data-v-7c904a26 class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div data-v-7c904a26 class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div data-v-7c904a26 class="content">
            <div data-v-7c904a26 class="top">{{$t('global.2019“现未来”科技艺术之星奖')}}</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img data-v-7c904a26 src="/static/peopleCenter/presentfuturethumb.jpg" />{{$t('global.2019“现未来”科技艺术之星奖组委会')}}
              </div>
              <span data-v-7c904a26 class="holdTime safari12">{{$t('global.即日起至')}}2019-04-30</span>
            </div>
          </div>
        </div>
      </router-link>
      <a
        href="https://mp.weixin.qq.com/s/g1LA80e4CGfak42FX8J0ZA"
        v-if="activityIndex ==3"
        class="pointer oneItem"
        target="_blank"
      >
        <div>
          <div class="item-img">
            <img src="https://image.manamana.net/LG%20fb.jpg?imageView2/1/w/746/h/420" />
            <div class="activity-kind" style="display: none;">{{$t('global.线下活动')}}</div>
            <div class="status-wrap" style="display: none;">{{$t('global.结束')}}</div>
          </div>
          <div class="content">
            <div data-v-7c904a26 class="top">2018 LIFE GEEK</div>
            <div data-v-7c904a26 class="bottom">
              <div data-v-7c904a26 class="font-overflow safari12">
                <img
                  data-v-7c904a26
                  src="https://image.manamana.net/avatar/1524824064/mana_o_1cc39hgch1ugrfhp13ok136u15jn7.png?imageView2/1/w/18/h/18"
                />LIFE GEEK
              </div>
              <span data-v-7c904a26 class="holdTime safari12">2018-06-08{{$t('global.至')}}2018-08-05</span>
            </div>
          </div>
        </div>
      </a>
    </template> -->
    <template v-if="activityIndex == 3">
      <div class="competitionBox clearfix">
        <div
          class="competitionLi"
          v-for="(item, i) in competitionList"
          :key="i"
        >
          <competition :item="item" />
        </div>
      </div>
      <pages
        :page-size="pagerParams.pageSize"
        :page-count="pagerParams.pageCount"
        :current-page.sync="pagerParams.currentPage"
        :total="pagerParams.total"
        @current-page-changed="OnCurrentPageChanged"
      ></pages>
    </template>
    <template v-if="activityIndex != 3">
      <router-link
        class="pointer"
        :class="{ oneItem: !otherstyle, oneItemother: otherstyle }"
        v-for="(item, index) in dataList"
        :key="index"
        :to="{ name: 'activityDetail', params: { id: item.id } }"
        target="_blank"
      >
        <div
          class="item-img"
          :style="
            item.thumb | bgImageUrl('/static/peopleCenter/item.png', 360, 480)
          "
        >
          <el-tooltip v-if="my_activity" placement="bottom-end" effect="light">
            <div slot="content">
              <span class="level" @click="gotoEdit(item.id, item.category)">{{
                $t("global.编辑活动")
              }}</span>
            </div>
            <el-button class="operate"></el-button>
          </el-tooltip>
        </div>
        <div class="content">
          <div class="top">{{ item.title }}</div>
          <!--<p class="status">
            <span
              class="status-wrap"
              :class="{'disabled': item.status == 4}"
            >{{ enums.activityStatus[item.status] }}</span>
          </p>-->
          <div class="bottom">
            <router-link
              class="font-overflow safari12"
              target="_blank"
              :to="'/peopleCenter/' + item.userId"
            >
              <img
                :src="
                  item.avatar
                    | imageUrl('/static/profile_img_default.png', 40, 40)
                "
              />
              {{ item.nickname }}
            </router-link>
          </div>
          <p class="date" v-if="item.holdEndTime">
            {{ dateFormatter(new Date(item.holdStartTime)) }}
            {{ $t("global.至") }}
            {{ dateFormatter(new Date(item.holdEndTime)) }}
          </p>
          <p class="date" v-if="!item.holdEndTime">
            {{ dateFormatter(new Date(item.holdStartTime)) }}
          </p>
          <p class="address">{{ item.cityName }} {{ item.place }}</p>
          <div class="tags">
            <span v-for="tag in item.tags">{{ tag }}</span>
          </div>
          <div class="price-wrap">
            <!-- <span class="fav">
              <i v-if="item.collectCount > 0">{{item.collectCount}}{{$t('global.人感兴趣')}}</i>
            </span> -->
            <span
              class="price"
              :class="{ end: Date.now() > item.holdEndTime }"
              v-if="item.joinType === 1"
            >
              <i>{{ item.price }}</i>
            </span>
            <span
              class="price"
              v-if="
                item.category === 2 &&
                item.joinType !== 1 &&
                Date.now() <= item.holdEndTime
              "
            >
              <i>{{ $t("global.免费") }}</i>
            </span>
            <span class="price end" v-if="Date.now() > item.holdEndTime">
              <i>{{ $t("global.已结束") }}</i>
            </span>
          </div>
        </div>
      </router-link>
    </template>
  </div>
</template>

<script>
import ActivityDialog from "@/pages/dialog/ActivityDialog";
import tools from "@/util/tools";
import pages from "@/components/pages.vue";
import competition from "@/components/activity/competition.vue";
export default {
  components: {
    ActivityDialog,
    pages,
    competition,
  },
  props: {
    dataList: Array,
    createShow: Boolean,
    otherstyle: Boolean,
    activityIndex: Number,
    my_activity: String,
  },
  data() {
    return {
      isLogin: localStorage.getItem("auth_token") !== null,
      userType: "",
      showDialog: false,
      origin: location.origin,
      competitionList: [],
      pagerParams: {
        pageSize: 10,
        pageCount: 10,
        currentPage: 1,
        total: 1,
      },
    };
  },
  methods: {
    getCompetition() {
      let params = {
        pageSize: this.pagerParams.pageSize,
        pageIndex: this.pagerParams.currentPage,
      };
      this.$http
        .get("/api/nmatch/", {
          params,
        })
        .then((res) => {
          if (res.code === "OK") {
            this.competitionList = res.data.list;
            this.pagerParams.currentPage = res.data.pageIndex;
            this.pagerParams.total = res.data.totalRecord;
          }
        });
    },
    OnCurrentPageChanged(val) {
      this.pagerParams.currentPage = val;
      this.getCompetition();
    },
    gotoEdit(id, category) {
      if (category === 1) {
        this.$router.push("/activityLunch?activityId=" + id);
      } else if (category === 2) {
        this.$router.push("/newActivityLunch?activityId=" + id);
      }
    },
    dateFormatter: tools.dateFormatter,
    getCategory: function (item) {
      let category = [
        "",
        this.$t("global.线上活动"),
        this.$t("global.线下活动"),
        this.$t("global.竞赛"),
      ];
      return category[item.category];
    },
    getStartTime: function (item) {
      let date =
        item.holdStartTime instanceof Date ? item.holdStartTime : new Date();
      return date;
    },
    gotoUrl() {
      if (this.userType == 2) {
        if (this.activityIndex === 3) {
          this.$router.push("/addmatch");
        } else {
          this.showDialog = true;
        }
      } else {
        this.$router.push("/ApplyIdentification");
        this.$message({
          showClose: true,
          message: this.$t("global.发起活动需要是认证的企业用户"),
        });
      }
    },
  },
  created() {
    if (this.isLogin) {
      this.$http.get("/api/u/info/get").then((response) => {
        let data = response.data;
        this.userType = data.userType;
      });
    }
    if (this.activityIndex === 3) {
      this.getCompetition();
    }
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
    activityIndex(val) {
      if (val === 3) {
        this.getCompetition();
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.font-overflow {
  color: #333;
  text-overflow: ellipsis; /* $t('global.只是起到注解作用') */
  white-space: nowrap; /* $t('global.不让文本换行') */
  overflow: hidden; /* $t('global.超出的部分显示')... */

  &:hover {
    color: #333;
  }
}

.activity-kind {
  position: absolute;
  width: 0.9rem;
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 0.5rem;
  font-size: 0.16rem;
  top: 0.27rem;
  left: 0.3rem;
}

.status {
  margin-top: 10px;
}

.status-wrap {
  display: inline-block;
  padding: 2px 10px;
  text-align: center;
  color: #3664ED;
  border: 1px solid #7C9AF3;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;

  &.disabled {
    color: #aaa;
    border-color: #ccc;
  }
}

.activity-content {
  /* width:1160px; */
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
  min-width: 800px;

  /* justify-content: space-between; */
  .oneItem {
    width: 540px;
    height: 240px;
    margin: 60px 40px 0 20px;
    padding-left: 180px;
    background: #ffffff;
    -webkit-box-shadow: 2px 2px 2px #eaeaea;
    -moz-box-shadow: 2px 2px 2px #eaeaea;
    box-shadow: 2px 2px 2px #eaeaea;
    border: 1px solid #d5d5d5;
    border-radius: 4px;
    position: relative;
    box-sizing: border-box;

    &:nth-child(2n) {
      margin-right: 0;
    }
  }

  .oneItemother {
    width: 600px;
    height: 240px;
    margin: 60px 0 0 0;
    padding-left: 180px;
    background: #ffffff;
    -webkit-box-shadow: 2px 2px 2px #eaeaea;
    -moz-box-shadow: 2px 2px 2px #eaeaea;
    box-shadow: 2px 2px 2px #eaeaea;
    border: 1px solid #d5d5d5;
    border-radius: 0.08rem;
    position: relative;
  }

  .item-img {
    /* width 3.56rem */
    position: absolute;
    top: -20px;
    left: -20px;
    width: 180px;
    border-radius: 4px;
    height: 240px;
    background: url('/static/peopleCenter/lifegeekbg.jpg') no-repeat center center;
    background-size: cover;
    box-shadow: 0 0 6px #ccc;
  }

  .content {
    position: relative;
    height: 198px;
    padding-right: 20px;
    color: #333333;

    .top {
      display: -webkit-box;
      max-height: 48px;
      font-size: 18px;
      font-weight: bold;
      margin-top: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
    }

    .date {
      margin-top: 10px;
      color: #999;
    }

    .address {
      margin-top: 10px;
      color: #999;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .tags {
      margin-top: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      span {
        margin-right: 10px;
        padding: 0 5px;
        color: #aaa;
        background: hsla(0, 0%, 76.5%, 0.1);
        border-radius: 4px;
      }
    }

    .center {
      color: #777777;
      margin-top: 0.06rem;
      font-size: 0.14rem;
    }

    .bottom {
      display: flex;
      margin-top: 10px;
      justify-content: space-between;

      img {
        /* display block */
        width: 18px;
        height: 18px;
        margin-right: 5px;
        border-radius: 50%;
        vertical-align: middle;
        border: 1px solid #e7e7e7;
      }

      .holdTime {
        color: #333333;
        font-weight: bold;
      }
    }

    .price-wrap {
      position: absolute;
      right: 20px;
      bottom: 0;
      left: 0;
      line-height: 24px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      .price {
        margin-right: 20px;

        i {
          font-weight: bold;
          color: #f55f54;
          font-size: 16px;
        }
      }

      .end {
        i {
          color: #999;
        }
      }

      .fav {
        float: right;
        color: #999;
      }
    }
  }
}

.pointer {
  cursor: pointer;
}

.activity-add {
  cursor: pointer;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding-top: 215px;
  text-align: center;
  font-size: 0.22rem;
  color: #333333;
}

.activity-add:before {
  content: '';
  display: block;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  width: 95%;
  height: 307px;
  position: absolute;
  left: 0.1rem;
  top: 0.1rem;
  border: 2px dotted #e1e1e1;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  border-radius: 6px;
}

.activity-add:after {
  content: '';
  display: block;
  width: 66px;
  height: 66px;
  background: url('/static/explore/add.png') no-repeat center center;
  background-size: contain;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -45px 0 0 -33px;
}

.el-tooltip__popper.is-light {
  border: none;
}

.operate:hover {
  background-color: #180826 !important;
  border-radius: 0.08rem;
}

.operate {
  width: 0.74rem;
  height: 0.3rem;
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.12rem 0;
  background: url('/static/peopleCenter/dot.png') no-repeat;
  background-size: 100%;
  border: none !important;

  span {
    display: block;
  }
}

.level {
  cursor: pointer;
}

.lifegeekcaps {
  width: 426.92px;
  height: 327pxpx;
  cursor: pointer;
  margin: 0.2rem 0.18rem 0 0;
  box-shadow: 2px 2px 2px #eaeaea;
  border: 1px solid #d5d5d5;
}

.lifegeekcaps img {
  width: 100%;
  height: 100%;
}

.activity-content>div, .oneItem + a {
  // width:calc((100% - 30px)/3) !important;
  box-sizing: border-box;
}

.oneItem + a .pointer {
  height: 327px;
}

.match-content {
  /* width:1160px; */
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;

  /* justify-content: space-between; */
  .oneItem {
    width: 373px;
    margin: 20px 20px 0 0;
    background: #ffffff;
    -webkit-box-shadow: 2px 2px 2px #eaeaea;
    -moz-box-shadow: 2px 2px 2px #eaeaea;
    box-shadow: 2px 2px 2px #eaeaea;
    border: 1px solid #d5d5d5;
    border-radius: 0.08rem;
    position: relative;

    &:nth-child(3n) {
      margin-right: 0;
    }
  }

  .oneItemother {
    width: 5.16rem;
    margin: 0.2rem 0.18rem 0 0;
    background: #ffffff;
    -webkit-box-shadow: 2px 2px 2px #eaeaea;
    -moz-box-shadow: 2px 2px 2px #eaeaea;
    box-shadow: 2px 2px 2px #eaeaea;
    border: 1px solid #d5d5d5;
    border-radius: 0.08rem;
    position: relative;

    &:nth-child(3n) {
      margin-right: 0.18rem;
    }
  }

  .item-img {
    /* width 3.56rem */
    position: relative;
    border-top-left-radius: 0.08rem;
    border-top-right-radius: 0.08rem;
    height: 210px;
    background-size: cover;
    border-radius: 0.06rem 0.06rem 0 0;

    img {
      width: 373px;
      height: 210px;
    }
  }

  .content {
    padding: 0 10px;
    color: #333333;

    .top {
      display: -webkit-box;
      height: 48px;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      margin-top: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .center {
      color: #777777;
      margin-top: 0.06rem;
      font-size: 0.14rem;
    }

    .bottom {
      display: flex;
      height: 46px;
      border-top: 1px solid #F4F4F4;
      justify-content: space-between;
      line-height: 46px;
      margin-top: 10px;

      img {
        /* display block */
        width: 18px;
        height: 18px;
        margin-right: 5px;
        border-radius: 50%;
        vertical-align: middle;
      }

      .holdTime {
        color: #333333;
        font-weight: bold;
      }
    }
  }
}

.competitionBox {
  width: 1110px;
  margin: 40px 0 0 25px;

  .competitionLi {
    float: left;
    margin-right: 30px;
    margin-bottom: 40px;
    width: 540px;
    height: 508px;
    background: #FFFFFF;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid #EBEBEB;
    box-sizing: border-box;
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/ActivityContent.vue